/**
 * Builds the funnel data array for the Campaign Analytics funnel chart.
 * Each step shows the value and the previous step's value so drop-off % can be calculated.
 *
 * @param {object} counts - { sentCount, deliveredCount, readCount, clickedCount, repliedCount, leadsCount }
 * @returns {Array}
 */
export const buildFunnelData = ({
  sentCount = 0,
  deliveredCount = 0,
  readCount = 0,
  clickedCount = 0,
  repliedCount = 0,
  leadsCount = 0,
}) => [
  { label: "Sent",      value: sentCount,      color: "bg-blue-500", prevValue: null          },
  { label: "Delivered", value: deliveredCount,  color: "bg-blue-500", prevValue: sentCount     },
  { label: "Read",      value: readCount,       color: "bg-blue-500", prevValue: deliveredCount },
  { label: "Clicked",   value: clickedCount,    color: "bg-blue-500", prevValue: readCount     },
  { label: "Replied",   value: repliedCount,    color: "bg-blue-500", prevValue: clickedCount  },
  { label: "Leads",     value: leadsCount,      color: "bg-blue-500", prevValue: repliedCount  },
];

/**
 * Returns a percentage string rounded to the nearest integer.
 * Returns "0%" if total is 0 or falsy.
 */
export const getPercentage = (value, total) => {
  if (!total || total === 0) return "0%";
  return `${Math.round((value / total) * 100)}%`;
};
